/**
 * Pastel sky palette for Phase 0/2 clear wash + distant-land illusion.
 * Playtest 2.15: true sky-blue clear + grass-similar mid-ground band
 * (lower above horizon); fog stays off.
 */

/** Soft sky-blue clear color — cozy, readable against dark HUD text. */
export const PASTEL_CLEAR = {
  /** hex for CSS / docs */
  hex: "#87CEEB",
  /** 0–1 RGB for Three.js Color */
  r: 135 / 255,
  g: 206 / 255,
  b: 235 / 255,
} as const;

/**
 * Grass-similar green for the distant mid-ground band just above the horizon
 * (illusion of more land beyond draw distance). Matches BLOCK GRASS ~[0.55,0.78,0.52].
 */
export const PASTEL_MIDGROUND = {
  hex: "#8CC785",
  r: 0.55,
  g: 0.78,
  b: 0.52,
} as const;

/** Alias kept for callers that want an explicit sky-blue name. */
export const PASTEL_SKY_BLUE = PASTEL_CLEAR;

export function pastelCss(): string {
  return PASTEL_CLEAR.hex;
}
